import React from 'react';

import { Button } from '@mui/material';

const MyButton = ({ children, sx = {}, variant = 'outlined', ...rest }) => {
  return (
    <Button
      sx={{
        padding: '5px 15px',
        fontWeight: '500',
        fontSize: '0.875rem',
        lineHeight: '1.75',
        letterSpacing: '0.02857em',
        textTransform: 'uppercase',
        minWidth: '100px',
        ...sx,
      }}
      variant={variant}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default MyButton;
